import { useEffect, useRef, useState } from 'react'
import { Button, SaveButton, useNotify } from 'react-admin'
import CheckIcon from '@mui/icons-material/Check'
import { useStyles } from '../styles'
import {
  Box,
  Button as ButtonM,
  FormHelperText,
  Grid,
  TextField,
  Toolbar,
} from '@material-ui/core'
import Api from '../../../Apis/api.service'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { useForm, Controller } from 'react-hook-form'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import config from '../../../config'
import { QuillEditor } from '../../common/QuillEditor'
const validationSchema = Yup.object().shape({
  libelle: Yup.string().required('Libelle is required'),
  majorite_bo: Yup.string().required('Majorite is required'),
})
const ReimportButton = ({ setLastRefreshTime, ...props }) => {
  const { record, setIsChanged, setIsDirtyEditor, setKey } = props
  const notify = useNotify()
  const classes = useStyles()

  const reload = () => {
    Api.ags3
      .update(record.id, {
        ...record,
        res_id: record.id,
        reload_contenu_bo: true,
      })
      .then((res) => {
        notify('Contenu réimporté')
        setIsDirtyEditor(false)
        setKey(Math.random().toString(36).substring(7))
        setIsChanged((prev) => {
          let newVal = new Date().getTime()
          return newVal
        })
      })
      .catch((err) => {
        notify(`${err.data.message}`, 'warning')
      })
  }

  return (
    <Grid item style={{ marginLeft: '1em' }}>
      <Button
        className={classes.actionButton}
        variant="contained"
        size="normal"
        color="secondary"
        label="Remplacer par le contenu Copromatic"
        onClick={reload}
      />
    </Grid>
  )
}

export const CustomResolutionToolbar = (props) => {
  const { errors, isDirty, onSubmit, handleSubmit } = props
  return (
    <Toolbar>
      <Button
        // className={classes.actionButton}
        sx={{
          backgroundColor: '#143a5f',
          color: 'white',
          '&:hover': { opacity: 0.8 },
        }}
        variant="contained"
        size="normal"
        color="secondary"
        label="Enregistrer"
        onClick={(e) => {
          e.preventDefault()
          handleSubmit(onSubmit)()
        }}
        startIcon={<CheckIcon />}
        disabled={Object.keys(errors).length || !isDirty}
      />
      <ReimportButton {...props} />
    </Toolbar>
  )
}

const CurrentResolutionForm = (props) => {
  const { record, onSuccess, setIsChanged, setIsSomeThingsChange } = props
  const choices = [
    { id: 'simple', name: 'simple (24 ou 25-1 DT)' },
    { id: 'absolue', name: 'absolue (25 ou 26-1 DT)' },
    { id: 'double', name: 'double (26)' },
    { id: 'unanimité', name: 'unanimité' },
    { id: 'sans vote', name: 'sans vote' },
  ]
  const {
    register,
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, dirtyFields },
    getValues,
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  })
  const [majorite_bo] = useState(record.majorite_bo)
  const [contenu_bo, setContenuBo] = useState(record.contenu_bo)
  const [isDirtyEditor, setIsDirtyEditor] = useState(false)
  const [key, setKey] = useState(Math.random().toString(36).substring(7))
  useEffect(() => {
    reset({
      libelle: record.libelle,
      majorite_bo: record.majorite_bo,
      contenu_bo: record.contenu_bo,
    })
  }, [record])
  const onSubmit = async (data) => {
    const result = await Api.resolutions.update(record.id, {
      ...record,
      ...data,
    })

    if (result.status === 200) {
      reset(data)
      setIsDirtyEditor(false)
      onSuccess(result)
    } else {
      alert(result.data.message)
    }
  }

  useEffect(() => {
    setIsSomeThingsChange((prev) => {
      if (!dirtyFields.libelle && !dirtyFields.majorite_bo && !isDirtyEditor) {
        return prev.filter((item) => item.id !== record.id)
      } else {
        return [
          ...prev,
          { id: record.id, libelle: record.libelle, numero: record.numero },
        ]
      }
    })
  }, [Object.keys(dirtyFields).length, isDirtyEditor])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <TextField
        // error
        {...register('libelle')}
        id="libelle"
        name="libelle"
        label="Libelle"
        defaultValue={record.libelle}
        variant="outlined"
        error={errors.libelle ? true : false}
      />
      <Box sx={{ marginTop: '10px' }}>
        <FormControl error={errors.majorite_bo ? true : false} fullWidth>
          <Controller
            render={({ field }) => (
              <>
                <InputLabel id="majorite_bo">Majorité</InputLabel>
                <Select {...field} labelId="majorite_bo" label="Majorité">
                  <MenuItem value="">
                    <em></em>
                  </MenuItem>
                  {choices.map((choice) => {
                    return <MenuItem value={choice.id}>{choice.name}</MenuItem>
                  })}
                </Select>
              </>
            )}
            control={control}
            name="majorite_bo"
            defaultValue={majorite_bo}
          />
        </FormControl>
        <Box sx={{ marginTop: '10px' }}>
          Clé de répartition :{' '}
          <span style={{ fontWeight: 'bold' }}>
            {record.repartition_libelle}
          </span>
        </Box>
        {/* contenu_bo */}
        <Box sx={{ marginTop: '10px' }}>
          {/*  */}
          <Controller
            control={control}
            name="contenu_bo"
            render={({ field: { onChange } }) => (
              <ReactQuill
                value={contenu_bo}
                onChange={(newValue, delta, source, editor) => {
                  setContenuBo(newValue)
                  if (source === 'user') {
                    setIsDirtyEditor(true)
                    onChange(newValue)
                    setValue('contenu_bo', newValue)
                  }
                }}
                modules={QuillEditor.modules}
              />
            )}
          />
        </Box>
        <CustomResolutionToolbar
          {...props}
          errors={errors}
          isDirty={
            dirtyFields.libelle || dirtyFields.majorite_bo || isDirtyEditor
          }
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          setKey={setKey}
          setIsDirtyEditor={setIsDirtyEditor}
        />
      </Box>
    </Box>
  )
}
export const ResolutionEdit = ({
  onFailure,
  onSuccess,
  lastRefreshTime,
  ...props
}) => {
  const record = props.record
  if (!record || !record.id) {
    return null
  }
  // @todo: change the method "Edit" to create when is a subresolution. Now it's not easy
  // to do because we are using an old version of react admin and do not allow that much
  // customization. Update this on react admin library update or refactor the whole form
  // to use a form without react admin that allow customization.

  return (
    <Box>
      <CurrentResolutionForm {...props} record={record} onSuccess={onSuccess} />
    </Box>
  )
}

export default ResolutionEdit
